uniform sampler2D uAlphaMap;
uniform vec3 uLightColor;
uniform vec2 uWindow1Pos;
uniform float uWindow1Rotation;
uniform float uWindow1Scale;
uniform vec2 uWindow1SampleOffset;
uniform vec2 uWindow2Pos;
uniform float uWindow2Rotation;
uniform float uWindow2Scale;
uniform vec2 uWindow2SampleOffset;
uniform float uAlpha;
uniform float uSecondScaleMul;
uniform float uSecondAlphaBoost;
uniform float uTime;

varying vec2 vUv;

// Function to rotate UV coordinates around a point
vec2 rotateUV(vec2 uv, vec2 center, float angle) {
    vec2 offset = uv - center;
    float cosAngle = cos(angle);
    float sinAngle = sin(angle);
    vec2 rotated = vec2(
        offset.x * cosAngle - offset.y * sinAngle,
        offset.x * sinAngle + offset.y * cosAngle
    );
    return rotated + center;
}

// Function to transform UV: scale and rotation around the center
vec2 transformUV(vec2 uv, vec2 center, float scale, float rotation) {
    vec2 offset = uv - center;
    
    // First scale
    offset = offset / scale;
    
    // Then rotate
    float cosAngle = cos(rotation);
    float sinAngle = sin(rotation);
    vec2 rotated = vec2(
        offset.x * cosAngle - offset.y * sinAngle,
        offset.x * sinAngle + offset.y * cosAngle
    );
    
    return center + rotated;
}

void main() {
    float alpha = 0.0;
    
    // Simple smooth movement for window 1
    vec2 w1Move = vec2(
        sin(uTime * 3.8 + 0.5) * 0.001,
        cos(uTime * 2.6 + 1.2) * 0.001
    );
    
    // Simple smooth movement for window 2
    vec2 w2Move = vec2(
        cos(uTime * 3.9 - 0.3) * 0.001,
        sin(uTime * 2.65 + 2.1) * 0.001
    );
    
    // Window 1: transformation (scale and rotation) with movement
    vec2 window1UV = transformUV(vUv, uWindow1Pos + w1Move, uWindow1Scale, uWindow1Rotation);
    window1UV += uWindow1SampleOffset;
    float alpha1 = texture2D(uAlphaMap, window1UV).r;
    
    // Second layer for window 1: with movement (slightly different for naturalness)
    vec2 w1Move2 = w1Move * 0.7;
    vec2 window1UV2 = transformUV(
        vUv,
        uWindow1Pos + w1Move2,
        uWindow1Scale * uSecondScaleMul,
        uWindow1Rotation
    );
    window1UV2 += uWindow1SampleOffset;
    float alpha1b = texture2D(uAlphaMap, window1UV2).r * uSecondAlphaBoost;
    float alphaWindow1 = max(alpha1, alpha1b);
    
    // Window 2: transformation (scale and rotation) with movement
    vec2 window2UV = transformUV(vUv, uWindow2Pos + w2Move, uWindow2Scale, uWindow2Rotation);
    window2UV += uWindow2SampleOffset;
    float alpha2 = texture2D(uAlphaMap, window2UV).r;
    
    // Second layer for window 2: with movement (slightly different for naturalness)
    vec2 w2Move2 = w2Move * 0.75;
    vec2 window2UV2 = transformUV(
        vUv,
        uWindow2Pos + w2Move2,
        uWindow2Scale * uSecondScaleMul,
        uWindow2Rotation
    );
    window2UV2 += uWindow2SampleOffset;
    float alpha2b = texture2D(uAlphaMap, window2UV2).r * uSecondAlphaBoost;
    float alphaWindow2 = max(alpha2, alpha2b);
    
    // Combine alpha channels from both windows (with the second layer)
    alpha = max(alphaWindow1, alphaWindow2);
    
    // Apply color and alpha
    gl_FragColor = vec4(uLightColor, alpha * uAlpha);
}


